import {
  API_RESPONSE_ERROR,
  API_RESPONSE_SUCCESS,
  CREATE_ACCOUNTS,
  DELETE_ACCOUNTS,
  GET_ACCOUNTS,
  GET_ACCOUNT_BY_ID,
  UPDATE_ACCOUNTS,
} from './actionType';

const INIT_STATE = {
  accounts: null,
  accountById: null,
  success: '',
  error: {},
  loading: true,
};

const Accounts = (state = INIT_STATE, action) => {
  switch (action.type) {
    case API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case GET_ACCOUNTS:
          return {
            ...state,
            accounts: action.payload.data,
            accountById: null,
            success: 'Successfully get accounts',
            error: {},
          };

        case GET_ACCOUNT_BY_ID:
          return {
            ...state,
            accountById: action.payload.data,
            success: '',
            error: {},
          };

        case CREATE_ACCOUNTS:
          return {
            ...state,
            success: 'Successfully created account',
            error: {},
          };

        case UPDATE_ACCOUNTS: {
          return {
            ...state,
            sucess: 'Successfully updated account',
            error: {},
          };
        }

        case DELETE_ACCOUNTS:
          return {
            ...state,
            success: 'Successfully deleted account',
            error: {},
          };

        default:
          return { ...state };
      }
    case API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case GET_ACCOUNTS:
          return {
            ...state,
            success: '',
            error: action.payload.error,
          };

        case GET_ACCOUNT_BY_ID:
          return {
            ...state,
            success: '',
            error: action.payload.error,
          };

        case CREATE_ACCOUNTS:
          return {
            ...state,
            success: '',
            error: action.payload.error,
          };

        case UPDATE_ACCOUNTS: {
          return {
            ...state,
            sucess: 'Successfully updated account',
            error: {},
          };
        }

        case DELETE_ACCOUNTS:
          return {
            ...state,
            success: '',
            error: action.payload.error,
          };

        default:
          return { ...state };
      }

    case GET_ACCOUNTS: {
      return {
        ...state,
      };
    }

    case GET_ACCOUNT_BY_ID: {
      return {
        ...state,
      };
    }

    case CREATE_ACCOUNTS: {
      return {
        ...state,
      };
    }

    case UPDATE_ACCOUNTS: {
      return {
        ...state,
      };
    }

    case DELETE_ACCOUNTS:
      return {
        ...state,
      };

    default:
      return { ...state };
  }
};

export default Accounts;
